export class Timeout {
  private timer: NodeJS.Timeout | null = null;

  // eslint-disable-next-line no-useless-constructor
  constructor(private delay: number) {}

  set<T>(cb: () => T): void {
    this.cancel();

    this.timer = setTimeout(() => {
      cb();
      this.cancel();
    }, this.delay);
  }

  cancel(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);

      if (typeof this.timer.unref === "function") {
        this.timer.unref();
      }

      this.timer = null;
    }
  }
}
